// frontend/client/src/ConnectionsPage.js
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "./auth";
import "./DashboardPage.css";

export default function ConnectionsPage() {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [followers, setFollowers] = useState([]);
  const [following, setFollowing] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch("/api/connections", { credentials: "include" });
        const data = await res.json().catch(() => null);

        if (!res.ok || !data || !data.ok) {
          throw new Error((data && data.error) || `HTTP ${res.status}`);
        }

        setFollowers(Array.isArray(data.followers) ? data.followers : []);
        setFollowing(Array.isArray(data.following) ? data.following : []);
      } catch (e) {
        setErr(e?.message || "Network error");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const PersonRow = ({ u }) => {
    const id = u?.id; // number
    const fullName = u?.fullName || "User";
    const university = u?.university || "";

    return (
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 18 }}>
        <img
          src={id ? `/post-author-avatar?userId=${encodeURIComponent(String(id))}` : "/avatar"}
          alt=""
          style={{
            width: 34,
            height: 34,
            borderRadius: 999,
            objectFit: "cover",
            background: "#111827",
            border: "2px solid rgba(255,255,255,0.45)",
            boxSizing: "border-box",
          }}
          onError={(e) => (e.currentTarget.style.display = "none")}
        />
        <div style={{ textAlign: "left" }}>
          <div style={{ fontSize: 14, fontWeight: 500 }}>{fullName}</div>
          <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 2 }}>
            {university}
          </div>
          <Link
            to={id ? `/user-profile?id=${encodeURIComponent(String(id))}` : "/dashboard"}
            style={{
              display: "inline-block",
              marginTop: 2,
              fontSize: 12,
              color: "#fbbf24",
              textDecoration: "none",
            }}
          >
            View profile
          </Link>
        </div>
      </div>
    );
  };

  const Column = ({ title, list, emptyText }) => (
    <section style={{ minWidth: 260 }}>
      <div style={{ fontSize: 20, fontWeight: 500, marginBottom: 20, textAlign: "center" }}>
        {title}
      </div>

      {list.length === 0 ? (
        <div style={{ fontSize: 13, color: "#9ca3af", textAlign: "left" }}>{emptyText}</div>
      ) : (
        list.map((u) => <PersonRow key={`${title}-${u?.id ?? "unknown"}`} u={u} />)
      )}
    </section>
  );

  return (
    <div className="dashboard-root">
      <div className="container">
        <header className="topbar">
          <div className="dashboard-title">GRADA · Connections</div>

          <button
            className="profile-btn"
            type="button"
            onClick={() => (window.location.href = "/profile")}
          >
            <img
              src="/avatar"
              alt=""
              className="avatar"
              onError={(e) => (e.currentTarget.style.display = "none")}
            />
            <div>
              <div className="profile-name">{user?.fullName || user?.name}</div>
              <div className="profile-sub">{user?.university}</div>
            </div>
          </button>
        </header>

        <main style={{ textAlign: "center" }}>
          {loading && <div style={{ fontSize: 13, color: "#9ca3af" }}>Loading...</div>}
          {err && <div style={{ fontSize: 13, color: "#9ca3af" }}>{err}</div>}

          {!loading && !err && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 80,
                  alignItems: "flex-start",
                  flexWrap: "wrap",
                }}
              >
                <Column title="Followers" list={followers} emptyText="No followers yet." />
                <Column title="Following" list={following} emptyText="You are not following anyone yet." />
              </div>

              <div style={{ marginTop: 40 }}>
                <button
                  type="button"
                  className="btn-logout"
                  onClick={() => (window.location.href = "/dashboard")}
                >
                  Back to main page
                </button>
              </div>
            </>
          )}
        </main>
      </div>
    </div>
  );
}
